import { render, staticRenderFns } from "./RestTempClosedExpired.vue?vue&type=template&id=73fd54e5"
import script from "./RestTempClosedExpired.vue?vue&type=script&lang=js"
export * from "./RestTempClosedExpired.vue?vue&type=script&lang=js"
import style0 from "./RestTempClosedExpired.vue?vue&type=style&index=0&id=73fd54e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports